import { style, media } from 'typestyle'
import { important } from 'csx'
export const pl8smi = style(media({ maxWidth: 576 }, { paddingLeft: important('8px') }))
